export const modifyDataForSelect = (data: Array<{name: string; id: number;}> | undefined) => data?.map(item => ({
    name: item.name,
    id: String(item.id),
}));
